const PATTERN = {
    NONE: 0,
    RANDOM: 1,
    BRICKS: 2,
    STARS: 3
}

export default PATTERN